import moment from 'moment'

import i18n from '@/i18n'
import { dialog } from '@/plugins/dialog'

export function loadFile(data, contentType, name, extension = contentType.split('/').pop()) {
	const tUrl = window.URL.createObjectURL(new Blob([data], { type: contentType }))
	const tmp1 = document.createElement('a')
	tmp1.href = tUrl
	tmp1.target = '_blank'
	tmp1.download = `${name}.${extension}`
	document.body.appendChild(tmp1)
	tmp1.click()
	URL.revokeObjectURL(tUrl)
	tmp1.remove()
}

export function numberFormaters(num) {
	return new Intl.NumberFormat('ru-RU').format(num)
}

export function getQuaterInterval(value) {
	if (!value) return []
	const [month, year] = value.split(',')
	const m = moment()

	m.set({ year: year, month: month })
	const start_quarter = m.startOf('month').format('YYYY-MM-D')
	const end_quarter = m.add('month', 2).endOf('month').format('YYYY-MM-D')

	return [start_quarter, end_quarter]
}

export function formatApiDateTime(dt) {
	if (!dt || typeof dt !== 'string') return ''
	return dt.replace('T', ' ').slice(0, 19)
}

// Уведомления приходят строкой в item.data. В этом канале `id` — получатель,
// а идентификатор модели лежит в message (например trade_id), поэтому в подстановку
// текста и ссылки отдаём message целиком.
export function parseNotification(item) {
	try {
		return JSON.parse(item.data)
	} catch (error) {
		return null
	}
}

function notificationKey(item, suffix) {
	const message = parseNotification(item)?.message
	if (!message) return null

	return `notification.${message.model}.${message.status}.${suffix}`
}

function notificationParams(item) {
	const payload = parseNotification(item)
	if (!payload) return {}

	return { id: payload.id, ...payload.message }
}

export function notificationText(item) {
	const key = notificationKey(item, 'text')
	return key ? i18n.t(key, notificationParams(item)) : ''
}

// Внешняя ссылка из самого уведомления — открывается как есть, без префикса локали
export function notificationLink(item) {
	return parseNotification(item)?.message?.link || null
}

export function hasNotificationHref(item) {
	const key = notificationKey(item, 'href')
	return !!key && i18n.te(key)
}

export function notificationHref(item) {
	const key = notificationKey(item, 'href')
	if (!key) return ''

	return '/' + i18n.locale + i18n.t(key, notificationParams(item))
}

// Сообщение про NCALayer было размножено по страницам тремя ветками if по локали —
// здесь один вызов кастомного диалога с переводом. Работает и вне контекста
// компонента: часть вызовов сидит во вложенных function-колбэках подписи ЭЦП.
export function alertNcaNotRunning() {
	return dialog.alert(i18n.t('system_message.nca_not_running'))
}
